<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1A1o5Ak/tc-custom/1.png?1685327485061?1709062148230" alt="This image is the cover for the book What Happens When..."/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What Happens When...
      </h1>
      <p class="bookDescription body article font2">
        <p>What happens when a child receives this book? Sit back and see how they learn the importance of everyday cleanliness with the miracle of simplicity.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Benjamin Schmidt
      </h2>
      
      <p class="authorDescription body article">Benjamin Schmidt creates and writes picture books for the future generations with exceptionally original ideas. Ben is of Hungarian origin and he has been living in London since the age of 20. When writing the first few lines, he was thinking of how to help bring up a better, more environmentally responsible and viable generation. He realized in that moment that he wants to create and write books that convey messages to children what they can take with themselves throughout their lives. His first book What Happens When… shows clearly that if you combine simplicity and clarity your message can be unbelievably effective.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2ba71ddc